/**
 * @file Drop task prognosed
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { TaskDrop } from './task-drop';
import * as moment from 'moment';
var TaskDropPrognosed = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDropPrognosed, _super);
    /**
     * Creates an instance of TaskDropPrognosed.
     */
    function TaskDropPrognosed(domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) {
        var _this = _super.call(this, domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) || this;
        // The exactPositioning value for the taskdropprognosed executor
        _this.exactPositioning = true;
        _this.name = 'task-drop-prognosed';
        _this.label = 'APP.EXECUTORS.TASK_DROP_PROGNOSED_NAME';
        return _this;
    }
    /**
     * The business logic for this executor and is executed after the validation step and before the finish step.
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    TaskDropPrognosed.prototype.process = function (data) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sliced, createEntities, _i, sliced_1, slice, targetcopy, start, prognosed, _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        sliced = this.explodeExecutorData(data);
                        createEntities = [];
                        _i = 0, sliced_1 = sliced;
                        _c.label = 1;
                    case 1:
                        if (!(_i < sliced_1.length)) return [3 /*break*/, 4];
                        slice = sliced_1[_i];
                        targetcopy = slice.target;
                        start = moment(targetcopy.start).clone();
                        prognosed = moment.duration(slice.item['Prognosed']).asMinutes() > 0 ? moment.duration(slice.item['Prognosed']) : moment.duration(60, 'minutes');
                        targetcopy.finish = start.add(prognosed);
                        _b = (_a = createEntities).push;
                        return [4 /*yield*/, this.createAssignment(targetcopy, slice.resource, slice.item, prognosed)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        _c.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, this.runPromisesParallelAndSave(createEntities)];
                }
            });
        });
    };
    /**
     * Creates an assignment
     * @param target timeslot
     * @param resource resource
     * @param item task
     * @param effort drop effort
     */
    TaskDropPrognosed.prototype.createAssignment = function (target, resource, item, effort) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var demandType = _this.domainService.getEntityType('Demand');
                        var demand = demandType.createEntity({
                            Task_Oid: item['Oid'],
                            Start: target.start.toDate(),
                            Finish: target.finish.toDate(),
                            Effort: effort.toISOString(),
                            SumFactor: item['SumFactor']
                        });
                        _this.domainService.addEntity(demand);
                        var deploymentType = _this.domainService.getEntityType('Deployment');
                        var deployment = deploymentType.createEntity({
                            Demand_Oid: demand['Oid'],
                            Start: target.start.toDate(),
                            Finish: target.finish.toDate(),
                            Resource_Oid: resource['Oid'],
                            Effort: effort.toISOString(),
                            SumFactor: item['SumFactor']
                        });
                        _this.domainService.addEntity(deployment);
                        var assignmentType = _this.domainService.getEntityType('Assignment');
                        var assignment = assignmentType.createEntity({
                            Deployment_Oid: deployment['Oid'],
                            Start: target.start.toDate(),
                            Finish: target.finish.toDate(),
                            Resource_Oid: resource['Oid'],
                            Color: item['Color'],
                            Effort: effort.toISOString(),
                            SumFactor: item['SumFactor']
                        });
                        _this.domainService.addEntity(assignment);
                        resolve(true);
                    })];
            });
        });
    };
    return TaskDropPrognosed;
}(TaskDrop));
export { TaskDropPrognosed };
